import { combineReducers } from 'redux'

import user from './user'
import common from './common'
import layout from './layout'
import searchPage from './searchPage'
import landingPage from './landingPage'
import marketing from './marketing'

const rootReducer = combineReducers({
  searchPage,
  landingPage,
  layout,
  user,
  common,
  marketing
})

export default rootReducer



// WEBPACK FOOTER //
// ./common/reducers/index.js